import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from './lib/api.ts';
import { App } from './App.tsx';
import './styles/base.css';
import './styles/components.css';
import './styles/forms.css';
import './styles/console.css';
import './styles/pages.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      // Run even when the browser reports offline: our API layer turns network
      // failures into typed errors and falls back to on-device data.
      networkMode: 'always',
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Only retry what can succeed later.
      retry: (n, e) => e instanceof ApiError && e.retryable && n < 2,
    },
    mutations: { networkMode: 'always' },
  },
});

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => {}));
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
